import {Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'circular-loader',
  templateUrl: './circular-loader.component.html',
  styleUrls: ['./circular-loader.component.scss']
})
export class CircularLoaderComponent implements OnInit {

  @Input() color;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/circular-loader/circular-loader.component.ts